import { getPlayValueIndexesFromArray } from '@/utils/misc';
/**
 * Defines the index position of each value inside a goal stat play.
 * @module playerGoalPlayIndexes
 */
const goalPlayValues = [
  'playId',
  'gameId',
  'playerId',
  'momentOfPlay',
  'categoryId',
  'categoryType',
  'matchLapse',
  'section',
  'matchResult',
  'playingAs',
  'total',
  'coordinateX',
  'coordinateY',
];

let goalPlayIndex = null;

export default function getGoalPlayIndexes() {
  if (!goalPlayIndex) {
    goalPlayIndex = getPlayValueIndexesFromArray(goalPlayValues);
  }
  return goalPlayIndex;
}
